// extracted by mini-css-extract-plugin
module.exports = {"menu__list":"styles_menu__list__1EyMW","menu__toggle":"styles_menu__toggle__3EiQx","menu__linkItem":"styles_menu__linkItem__2l83K"};